import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import { ENV_ANDROID, ENV_IOS } from '../../const';
import { env } from '../../getNativeInfo';
import { notInApp, prepareApi, uniCall } from '../../utils';
prepareApi(['bcz_alipay', 'bcz_weixinpay', 'bcz_qqpay', 'bcz_system']);
/**
 * 订单支付
 * @deprecated 建议使用 `requestPay` 和 `buyVirtualProduct` 方法
 */

export function pay(_a) {
  var type = _a.type,
      orderInfo = _a.orderInfo;
  return new Promise(function (resolve, reject) {
    switch (type) {
      // 支付宝支付
      case 'alipay_mob_client':
        {
          window.bcz_alipay.onPayResult = function (result) {
            var ret = /resultStatus=[{"](\d+)[}"]/.exec(result) || {};

            if (ret[1] === '9000') {
              resolve();
              console.log('ali successed');
            } else {
              console.log('ali wrong');
              reject(new Error('ali wrong reject'));
            }
          };

          if (env === ENV_IOS || env === ENV_ANDROID) {
            uniCall({
              api: 'pay',
              param: orderInfo,
              prefix: 'bcz_alipay'
            });
          } else {
            reject(notInApp({
              api: "pay via ".concat(type),
              param: orderInfo
            }));
          }

          break;
        }
      // 微信支付

      case 'weixin_app':
        {
          window.bcz_weixinpay.onPayResult = function (result) {
            try {
              var ret = JSON.parse(result);

              if (ret.errCode === 0) {
                resolve();
              }
            } catch (err) {
              reject(new Error('pay - weixin_app - parse error'));
            }
          };

          if (env === ENV_IOS || env === ENV_ANDROID) {
            uniCall({
              api: 'pay',
              param: orderInfo,
              prefix: 'bcz_weixinpay'
            });
          } else {
            reject(notInApp({
              api: "pay via ".concat(type),
              param: orderInfo
            }));
          }

          break;
        }
      // QQ 支付

      case 'qq_app':
        {
          window.bcz_qqpay.onPayResult = function (result) {
            try {
              var ret = JSON.parse(result);

              if (ret.errCode === 0) {
                resolve();
              }
            } catch (err) {
              reject(new Error('pay - qq_app - parse error'));
            }
          };

          if (env === ENV_IOS || env === ENV_ANDROID) {
            uniCall({
              api: 'pay',
              param: orderInfo,
              prefix: 'bcz_qqpay'
            });
          } else {
            reject(notInApp({
              api: "pay via ".concat(type),
              param: orderInfo
            }));
          }

          break;
        }
      // 虚拟币支付

      case 'coin_v3':
        {
          window.bcz_system.buyVirtualProductPayResult = function (rawData) {
            var data;

            try {
              if (typeof rawData === 'object') {
                data = rawData;
              } else {
                data = JSON.parse(rawData);
              }

              if (data.code === 1 || data.code === 0) {
                resolve(data);
              } else {
                reject(new Error(data.message));
              }
            } catch (err) {
              reject(new Error('pay - coin_v3 - parse error'));
            }
          };

          if (env === ENV_IOS) {
            window.webkit.messageHandlers.bcz_system_buyVirtualProduct.postMessage(orderInfo);
          } else if (env === ENV_ANDROID) {
            reject(new Error('Android 不能使用虚拟币购买'));
          } else {
            reject(notInApp({
              api: "pay via ".concat(type),
              param: orderInfo
            }));
          }

          break;
        }

      default:
        {
          reject(new Error("Wrong Pay Type: ".concat(type)));
          break;
        }
    }
  });
}